import { NFT } from "thirdweb";
import { NFTPackage } from "./NFTPackage";

export class NFTGiftPackage extends NFTPackage {
    public constructor(nft: NFT) {
        super(nft);
    }
}